import React from 'react';
import { wrapper } from '@/redux/store';
import AppLayout from '@/components/AppLayout';
import ShopDetail from '@/feat-components/ShopDetail';
import { displayGateway } from '@/di-container/display/gateway/server';
import { FloatingGroup } from '@/components/FloatingGroup';
import TrackingService from '@/services/tracking';

export interface ShopDetailPageProps {
  shopId: number;
  dispTemplateNo?: string;
}

const ShopDetailPage = (props: ShopDetailPageProps) => {
  return (
    <>
      <AppLayout
        floatingArea={
          <FloatingGroup
            {...TrackingService.tagGTM('shop_detail_scroll_top_button')}
          />
        }
        content={<ShopDetail {...props} />}
      />
    </>
  );
};

export default ShopDetailPage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query: { id } }) => {
      const props: ShopDetailPageProps = {
        shopId: Number(id) || 0,
      };
      const { getTemplateInfo } = displayGateway();
      const apiResponse = await getTemplateInfo.exec({
        typeValue: 'PC',
      });

      if (apiResponse.code === 200) {
        props.dispTemplateNo = apiResponse.data?.find(
          (item) => item.key === 'shopIntAgntDetailTemplateNo',
        )?.value;
      }

      return {
        props: {
          ...props,
        },
      };
    },
);
